import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API, useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser, applyToken } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        if (res.data?.token && applyToken) applyToken(res.data.token);
        setUser(res.data.user);
        // Clean hash, navigate to dashboard
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate('/dashboard', { replace: true, state: { user: res.data.user } });
      } catch (e) {
        setError('Sign-in failed. Please try again.');
        setTimeout(() => navigate('/login', { replace: true }), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0d0e10] text-white">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#1f2024] loader-ring rounded-full mx-auto" />
        <p className="mt-4 text-white/70">{error || 'Signing you in...'}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
